export const scrollLock = {
  _reverseStyle(): void {
    // void
  },
  enable(): void {
    try {
      const $html = document.documentElement;
      if ($html.style.overflow) return;
      const htmlStyle = { ...$html.style };
      const scrollBarWidth = window.innerWidth - $html.clientWidth;
      const previousPaddingRight = parseInt(
        window.getComputedStyle($html).paddingRight,
        10,
      );

      queueMicrotask(() => {
        $html.style.overflow = "hidden";
        $html.style.boxSizing = "border-box";
        $html.style.touchAction = "none";
        $html.style.paddingRight = `${scrollBarWidth + previousPaddingRight}px`;
        this._reverseStyle = () => {
          const $html = document.documentElement;
          (
            ["overflow", "boxSizing", "paddingRight", "touchAction"] as const
          ).forEach((x) => {
            $html.style[x] = htmlStyle[x] || "";
          });
        };
      });
    } catch {
      this.disable();
    }
  },
  disable(): void {
    this._reverseStyle();
    this._reverseStyle = () => {
      // void
    };
  },
};

export default scrollLock;
